import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FetchIncomeTaxPreviewQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
}>;

export type FetchIncomeTaxPreviewQuery = {
  __typename?: "Query";
  incomeTaxPreview: {
    __typename?: "IncomeTaxPreview";
    year: number;
    periodFrom: string;
    periodTo: string;
    hasDataBasis: boolean;
    bookedTransactionsCount: number;
    isTradeBusiness: boolean;
    profit?: number | null;
    whatIsYours?: number | null;
    whatIsYoursNote?: string | null;
    averageTaxRate?: number | null;
    burdenNote?: string | null;
    warnings: Array<string>;
    burden?: {
      __typename?: "IncomeTaxPreviewBurden";
      taxOffice: number;
      municipality: number;
      municipalityName?: string | null;
      total: number;
    } | null;
    positions: Array<{
      __typename?: "IncomeTaxPreviewPosition";
      key: Types.IncomeTaxPreviewPositionKey;
      group: Types.IncomeTaxPreviewPositionGroup;
      label: string;
      status: Types.IncomeTaxPreviewPositionStatus;
      amount?: number | null;
      provenanceKind?: Types.IncomeTaxPreviewProvenanceKind | null;
      source?: string | null;
      periodFrom?: string | null;
      periodTo?: string | null;
      note?: string | null;
      reason?: string | null;
    }>;
  };
};

export const FetchIncomeTaxPreviewDocument = gql`
  query FetchIncomeTaxPreview($email: String!) {
    incomeTaxPreview(email: $email) {
      year
      periodFrom
      periodTo
      hasDataBasis
      bookedTransactionsCount
      isTradeBusiness
      profit
      whatIsYours
      whatIsYoursNote
      averageTaxRate
      burden {
        taxOffice
        municipality
        municipalityName
        total
      }
      burdenNote
      warnings
      positions {
        key
        group
        label
        status
        amount
        provenanceKind
        source
        periodFrom
        periodTo
        note
        reason
      }
    }
  }
`;

/**
 * __useFetchIncomeTaxPreviewQuery__
 *
 * To run a query within a React component, call `useFetchIncomeTaxPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchIncomeTaxPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchIncomeTaxPreviewQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFetchIncomeTaxPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchIncomeTaxPreviewQuery,
    FetchIncomeTaxPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchIncomeTaxPreviewQuery,
    FetchIncomeTaxPreviewQueryVariables
  >(FetchIncomeTaxPreviewDocument, options);
}
export function useFetchIncomeTaxPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchIncomeTaxPreviewQuery,
    FetchIncomeTaxPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchIncomeTaxPreviewQuery,
    FetchIncomeTaxPreviewQueryVariables
  >(FetchIncomeTaxPreviewDocument, options);
}
export type FetchIncomeTaxPreviewQueryHookResult = ReturnType<
  typeof useFetchIncomeTaxPreviewQuery
>;
export type FetchIncomeTaxPreviewLazyQueryHookResult = ReturnType<
  typeof useFetchIncomeTaxPreviewLazyQuery
>;
export type FetchIncomeTaxPreviewQueryResult = Apollo.QueryResult<
  FetchIncomeTaxPreviewQuery,
  FetchIncomeTaxPreviewQueryVariables
>;
